{
  "title": "Tableau de bord",
  "description": "Aperçu des performances et analyses de votre entreprise ou institution",
  "descriptionSelect": "Sélectionnez une entreprise ou institution pour voir les analyses",
  "descriptionGetStarted": "Commencez par créer votre première entreprise ou institution",
  "greetingMorning": "Bonjour",
  "greetingAfternoon": "Bon après-midi",
  "greetingEvening": "Bonsoir",
  "welcomeSubtitle": "Voici ce qui se passe aujourd'hui avec votre entreprise ou institution.",
  "emptyNoBusinessTitle": "Aucune entreprise ou institution",
  "emptyNoBusinessDescription": "Créez votre première entreprise ou institution pour gérer vos services, rendez-vous et plus encore.",
  "emptyNoBusinessCta": "Créer votre première entreprise ou institution",
  "emptyNoBusinessHint": "Vous pouvez créer plusieurs entreprises ou institutions et basculer entre elles à tout moment.",
  "emptyNotSelectedTitle": "Aucune entreprise ou institution sélectionnée",
  "emptyNotSelectedDescription": "Veuillez sélectionner une entreprise ou institution dans la barre latérale pour voir ses analyses.",
  "loadError": "Impossible de charger les données du tableau de bord.",
  "tryAgain": "Réessayer",
  "chartBookings": "Graphique des réservations indisponible",
  "chartFulfillment": "Graphique d'exécution indisponible",
  "chartRevenue": "Graphique des revenus indisponible",
  "chartCustomerGrowth": "Graphique de croissance clients indisponible",
  "chartAppointmentStatus": "Graphique des statuts de rendez-vous indisponible",
  "chartServicePerformance": "Graphique de performance des services indisponible",
  "chartPeakHours": "Graphique des heures de pointe indisponible",
  "chartRatings": "Graphique des évaluations indisponible",
  "chartAppointmentsTable": "Tableau des rendez-vous indisponible",
  "starSingular": "Étoile",
  "starPlural": "Étoiles",
  "charts": {
    "timeRange": {
      "placeholder": "Sélectionner la période",
      "daily": "Quotidien",
      "monthly": "Mensuel",
      "yearly": "Annuel"
    },
    "trend": {
      "up": "Tendance à la hausse de {{percent}} % ce mois-ci",
      "down": "Tendance à la baisse de {{percent}} % ce mois-ci"
    },
    "ranges": {
      "last10Days": "10 derniers jours",
      "last6Months": "6 derniers mois"
    },
    "bookings": {
      "title": "Réservations totales",
      "description": "Réservations complétées sur les 10 derniers jours",
      "metricLabel": "Réservations"
    },
    "revenue": {
      "title": "Revenus",
      "description": "Revenus totaux générés sur les 6 derniers mois",
      "metricLabel": "Revenus",
      "totalPrefix": "Total : GH₵{{total}}",
      "rangeWithTotal": "{{range}} • Total : GH₵{{total}}"
    },
    "fulfillment": {
      "title": "Taux d'exécution des services",
      "description": "Pourcentage de services complétés",
      "fulfilledLabel": "Exécuté",
      "target": "Objectif",
      "current": "Actuel"
    },
    "customerGrowth": {
      "title": "Croissance des clients",
      "description": "Nouveaux et clients récurrents sur les 6 derniers mois",
      "labels": {
        "new": "Nouveaux clients",
        "returning": "Clients récurrents"
      },
      "summary": "{{range}} • Nouveaux : {{new}} • Récurrents : {{returning}}"
    },
    "customerSatisfaction": {
      "title": "Satisfaction client",
      "description": "Répartition des notes issues des avis clients",
      "metricLabel": "Avis",
      "averageRating": "Note moyenne : {{rating}}/5",
      "fromReviews": "sur {{count}} avis",
      "averageRatingFromReviews": "Note moyenne : {{rating}}/5 sur {{count}} avis",
      "ratingLabel": "{{count}} {{starLabel}}"
    },
    "appointmentStatus": {
      "title": "Statut des rendez-vous",
      "description": "Répartition des rendez-vous par statut",
      "total": "Total des rendez-vous : {{total}}",
      "statuses": {
        "COMPLETED": "Terminé",
        "PENDING": "En attente",
        "CANCELLED": "Annulé",
        "RESCHEDULED": "Replanifié",
        "ACTIVE": "Actif"
      }
    },
    "peakHours": {
      "title": "Heures de pointe",
      "description": "Répartition des réservations au cours de la journée",
      "metricLabel": "Réservations",
      "peakBookingTime": "Heure de pointe :"
    },
    "servicePerformance": {
      "title": "Performance des services",
      "description": "Réservations et revenus par type de service",
      "labels": {
        "bookings": "Réservations",
        "revenue": "Revenus"
      },
      "topService": "Meilleur service : {{service}}",
      "noServices": "Aucun service"
    },
    "appointmentsTable": {
      "title": "Rendez-vous à venir",
      "description": "Prochains rendez-vous planifiés à partir d'aujourd'hui (UTC)",
      "fallbacks": {
        "customer": "Client",
        "service": "Service",
        "time": "--"
      },
      "columns": {
        "customer": "Client",
        "name": "Nom",
        "service": "Service",
        "dateTime": "Date et heure"
      },
      "empty": {
        "title": "Aucun rendez-vous à venir",
        "descriptionWithBusiness": "Aucun rendez-vous planifié à partir d'aujourd'hui pour cette entreprise ({{businessId}}). Si vous en attendez un, vérifiez qu'il appartient bien à cette entreprise dans la page Rendez-vous.",
        "descriptionWithoutBusiness": "Aucun rendez-vous planifié à partir d'aujourd'hui pour l'entreprise sélectionnée."
      }
    }
  },
  "quickActions": {
    "title": "Actions rapides",
    "addProvider": "Ajouter un prestataire",
    "newService": "Nouveau service",
    "appointments": "Rendez-vous",
    "income": "Revenus"
  },
  "kpi": {
    "totalBookings": "Réservations totales",
    "totalBookingsDescription": "Réservations depuis le début",
    "totalRevenue": "Revenus totaux",
    "totalRevenueDescription": "Gains totaux",
    "totalCustomers": "Clients totaux",
    "totalCustomersDescription": "Clients actifs",
    "averageRating": "Note moyenne",
    "averageRatingDescription": "Satisfaction client",
    "notAvailable": "N/D",
    "changeFromLastPeriod": "{{percent}} % par rapport à la période précédente"
  },
  "onboarding": {
    "title": "Préparez votre entreprise",
    "progress": "{{completed}} sur {{total}} étapes terminées",
    "dismiss": "Masquer la liste",
    "pendingApproval": "Votre entreprise est en attente d'approbation. La plupart des étapes se débloquent une fois votre profil vérifié par un administrateur.",
    "continue": "Continuer : {{step}}",
    "steps": {
      "approved": {
        "title": "Entreprise approuvée",
        "descriptionApproved": "Votre entreprise est vérifiée et prête pour la configuration.",
        "descriptionPending": "Votre entreprise est en cours d'examen. Vous pourrez préparer prestataires et services une fois approuvée.",
        "descriptionRejected": "Votre entreprise n'a pas été approuvée. Contactez le support ou mettez à jour votre profil."
      },
      "providers": {
        "title": "Ajouter un prestataire",
        "description": "Les prestataires assurent vos services et sont assignés aux unités."
      },
      "services": {
        "title": "Créer un service",
        "description": "Définissez ce que les clients peuvent réserver — nom, tarif et image."
      },
      "units": {
        "title": "Configurer unités et disponibilités",
        "description": "Ajoutez des unités de service avec prestataires et créneaux hebdomadaires."
      },
      "activate": {
        "title": "Activer pour les clients",
        "description": "Rendez votre service visible dans l'application client."
      }
    }
  }
}
